import { authenticatedFetch } from '../context/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

/**
 * Service pour gérer les participations aux tournois
 */
const participationsService = {
  /**
   * Récupérer toutes mes participations
   */
  getMyParticipations: async () => {
    const response = await authenticatedFetch(`${API_BASE_URL}/participations/me`);
    if (!response.ok) throw new Error('Erreur lors de la récupération des participations');
    const data = await response.json();
    return data.data || [];
  },

  /**
   * Récupérer mes participations à un festival
   */
  getMyParticipationsInFestival: async (festivalId) => {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/participations/me/festival/${festivalId}`
    );
    if (!response.ok) throw new Error('Erreur lors de la récupération des participations');
    const data = await response.json();
    return data.data || [];
  },

  /**
   * Vérifier si je participe à un tournoi
   */
  checkTournamentParticipation: async (tournamentId) => {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/participations/check/tournament/${tournamentId}`
    );
    if (!response.ok) throw new Error('Erreur lors de la vérification');
    const data = await response.json();
    return data.data?.participating || false;
  },

  /**
   * Vérifier si je participe à un festival
   * Retourne { participating: boolean, tournamentsCount: number }
   */
  checkFestivalParticipation: async (festivalId) => {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/participations/check/festival/${festivalId}`
    );
    if (!response.ok) throw new Error('Erreur lors de la vérification');
    const data = await response.json();
    return data.data || { participating: false, tournamentsCount: 0 };
  },

  /**
   * S'inscrire à un tournoi
   */
  registerToTournament: async (tournamentId, notes = '') => {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/participations/tournament/${tournamentId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ notes }),
      }
    );
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de l\'inscription');
    }
    const data = await response.json();
    return data.data;
  },

  /**
   * Confirmer une participation
   */
  confirmParticipation: async (participationId) => {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/participations/${participationId}/confirm`,
      {
        method: 'PUT',
      }
    );
    if (!response.ok) throw new Error('Erreur lors de la confirmation');
    const data = await response.json();
    return data.data;
  },

  /**
   * Annuler une participation
   */
  cancelParticipation: async (participationId) => {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/participations/${participationId}/cancel`,
      {
        method: 'PUT',
      }
    );
    if (!response.ok) throw new Error('Erreur lors de l\'annulation');
    const data = await response.json();
    return data.data;
  },

  /**
   * Se désinscrire complètement
   */
  deleteParticipation: async (participationId) => {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/participations/${participationId}`,
      {
        method: 'DELETE',
      }
    );
    if (!response.ok) throw new Error('Erreur lors de la désinscription');
    const data = await response.json();
    return data;
  },

  /**
   * ✅ AJOUTÉ : Se désinscrire d'un tournoi (directement par tournamentId)
   */
  unregisterFromTournament: async (tournamentId) => {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/participations/tournament/${tournamentId}`,
      {
        method: 'DELETE',
      }
    );
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de la désinscription');
    }
    const data = await response.json();
    return data.data;
  },

  /**
   * Récupérer les participants à un tournoi (Admin)
   */
  getTournamentParticipants: async (tournamentId) => {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/participations/tournament/${tournamentId}`
    );
    if (!response.ok) throw new Error('Erreur lors de la récupération des participants');
    const data = await response.json();
    return data.data || [];
  },
};

export default participationsService;